import React from 'react'
import { Container, Paper, Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { getAllUsers } from '../../Helpers/UserHelpers';
import AddUser from './AddUser';
import MaterialTable from 'material-table';
import Loading from '../Loading/Loading';

class ManageUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: null,
            dialogOpen: false,
            columns: [
                { title: "Name", field: 'displayName' },
                { title: "E-mail", field: 'email' },
                { title: "Access Level", field: 'accessLevel' },

            ]
        }
        this.getUsers();
    }

    getUsers = () => {
        getAllUsers()
            .then(users => {
                this.setState({ users })
            })
            .catch(error => console.log(error));
    }

    handleAddUserClick = () => {
        this.setState({ dialogOpen: true })
    }

    handleDialogClose = () => {
        this.setState({ dialogOpen: false });
    }

    renderAddUserForm = () => (
        <div>
            <Dialog open={this.state.dialogOpen} onClose={this.handleDialogClose}>
                <DialogTitle>Add user</DialogTitle>
                <DialogContent>
                    <AddUser />
                </DialogContent>
            </Dialog>
        </div>
    )
    
    render() {
        return (
            <div>
                { this.renderAddUserForm() }
                <Container>
                    <Paper>
                        <div>
                            <Button variant="outlined" color="primary" onClick={this.handleAddUserClick}>Add user</Button>
                        </div>
                        {this.state.users === null 
                            ? <Loading />
                            : 
                            <MaterialTable
                                title="Users" 
                                data={this.state.users}
                                columns={this.state.columns} />
                            }
                    </Paper>
                </Container>
            </div>
        )
    }
}

export default ManageUsers;